export default {
  es: {
    title: 'Acerca de',
    version: 'Versión',
    termsAndConditions: 'Términos y condiciones',
    privacyPolicy: 'Política de privacidad',
    copyRight:
      '©Copyright 2025 Vantive. Todos los derechos reservados. Nefroplus - Renal Care Services by Vantive'
  },
  en: {
    title: 'About',
    version: 'Version',
    termsAndConditions: 'Terms and conditions',
    privacyPolicy: 'Privacy policy',
    copyRight:
      '©Copyright 2025 Vantive. All rights reserved. Nefroplus - Renal Care Services by Vantive'
  }
};
